import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $inputs } = this;

  return (view = ViewFactory({
    NAME: '1VOUCHER_CONFIRM_VIEW',
    constants: {
      hasBackAction: false,
      get changeVoucher() { return $this.CHANGE_VOUCHER },
      get phone() { return getValueAtPath($inputs, '[phone].value') }
    },
    next() { SuccessView && SuccessView.activate.call($this) }
  }).call(this));
}
